import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6621a932"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-content" }
const _hoisted_2 = { class: "detail-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, null, -1))

import { useRouter, useRoute } from 'vue-router'
import { PullRefresh, Toast } from 'vant'
import AppHeader from '@/components/Header.vue'
import { ref, Ref } from 'vue'
import type { CardTabItemRenderType } from '@/types/my-credentials'
import { GetPhotoStatus, GetCredentialsList } from '@/apis/my-credentials'
import type {
  GetPhotoStatusResult,
  GetCredentialsListDataItem,
  CardItemRenderType,
} from '@/types/my-credentials'
import dayjs from 'dayjs'

import { clearToast } from '@/utils/tools'
import { onMounted, watch } from 'vue'
import AppHost from '@/utils/app'

import { useStore } from 'vuex'
import { defineComponent } from 'vue'
import HeaderInfo from './component/header-info.vue'
import JumpBlock from './component/jump-block.vue'
import ChangPhoto from './component/change-photo.vue'
import IdentityInformaiton from './component/identity-informaiton.vue'
const __default__ = defineComponent({
  components: { HeaderInfo, JumpBlock, ChangPhoto, IdentityInformaiton },
  name: 'my-credentials-detail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $store = useStore()
const $router = useRouter()
const $route = useRoute()

const headerInfoData = ref({
  status: 0,
  name: '',
  phone: '',
  photo: '',
  notPassReason: '',
})
const userCardList: Ref<GetCredentialsListDataItem[]> = ref([])
const cardData = ref([])

const refreshing = ref(false)
const isFistLoading = ref(false)

function headerInfoHandle(GetPhotoStatusData: GetPhotoStatusResult) {
  headerInfoData.value.status = GetPhotoStatusData.status
  headerInfoData.value.name = GetPhotoStatusData.user.name
  headerInfoData.value.photo = GetPhotoStatusData.photo
  headerInfoData.value.phone = GetPhotoStatusData.user.mobile
  headerInfoData.value.notPassReason = GetPhotoStatusData.no_pass_reason
}

function formatCardItemData(item: GetCredentialsListDataItem): CardItemRenderType {
  let user = item.user
  return {
    ...item,
    name: user.name,
    birthDay: user.birthday,
    gender: user.gender,
    createTime: dayjs(item.event_at * 1000).format('YYYY/MM/DD'),
    validityPeriod: dayjs(item.expire_at * 1000).format('YYYY/MM/DD'),
    issuingAuthority: user.issuing_authority,
    id: user.code,
    cardType: item.card_type,
    type: item.type,
    isActive: item.active === 1,
    isApply: item.is_apply === 1,
    isCanCertificateApply: item.can_certificate_apply === 1,
    cardName: `${item.category_name}${item.card_type_name}`,
    code: user.code,
  }
}
function cardDataHandle(data: Array<GetCredentialsListDataItem>) {
  let cardMap: Map<number, CardTabItemRenderType> = new Map()
  ;(data || []).forEach((_) => {
    if (cardMap.has(_.category)) {
      cardMap.get(_.category).cardData.push(formatCardItemData(_))
    } else {
      cardMap.set(_.category, {
        title: _.category_name,
        cardData: [formatCardItemData(_)],
      })
    }
  })
  // 对每个证件类型排序
  cardMap.forEach((item, key) => {
    item.cardData.sort((pre, next) => {
      let flag = 0
      if (pre.isActive && !next.isActive) {
        flag = -1
      } else if (!pre.isActive && next.isActive) {
        flag = 1
      }
      return flag
    })
  })
  const beofreSortData = [...cardMap.values()]
  cardData.value = beofreSortData.map((item) => {
    return {
      ...item,
      cardData: item.cardData.sort((card1, card2) => {
        return card1.sort - card2.sort
      }),
    }
  })
}

async function initData() {
  let data = await Promise.all([GetPhotoStatus(), GetCredentialsList()])
  headerInfoHandle(data[0])
  cardDataHandle(data[1])

  userCardList.value = data[1]
}

async function onRefresh() {
  try {
    await initData()
  } catch (e) {
    console.log('onRefresh', e)
  }
  refreshing.value = false
}

async function successHandle() {
  let toast = Toast({
    type: 'loading',
    message: '获取数据中...',
    forbidClick: true,
    duration: 0,
  })
  try {
    await initData()
  } catch (e) {
    console.log('onMounted')
  }
  toast.clear()
}

function headerInfoJumpHandle() {
  console.log('headerInfoJumpHandle')
  isShowChangePhoto.value = true
}

const isShowChangePhoto = ref(false)

onMounted(async () => {
  let toast = Toast({
    type: 'loading',
    message: '获取数据中...',
    forbidClick: true,
    duration: 0,
  })
  try {
    isFistLoading.value = true
    await initData()
  } catch (e) {
    console.log('onMounted')
  }
  isFistLoading.value = false
  toast.clear()
  clearToast()
})

function leftClickHandle() {
  AppHost.goAppBack()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "我的证件",
      isReturnLeftEvent: true,
      onLeftClick: leftClickHandle
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(PullRefresh), {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh,
        class: "detail-wrap"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createVNode(HeaderInfo, _mergeProps(headerInfoData.value, {
              userCardList: userCardList.value,
              onUpload: headerInfoJumpHandle
            }), null, 16, ["userCardList"]),
            _createVNode(JumpBlock),
            _createVNode(IdentityInformaiton, {
              class: "grow",
              photo: headerInfoData.value.photo,
              status: headerInfoData.value.status,
              cardData: cardData.value,
              onUpload: headerInfoJumpHandle
            }, null, 8, ["photo", "status", "cardData"])
          ], 512), [
            [_vShow, !isFistLoading.value]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ChangPhoto, {
        tipShow: isShowChangePhoto.value,
        "onUpdate:tipShow": _cache[1] || (_cache[1] = ($event: any) => ((isShowChangePhoto).value = $event)),
        onSuccess: successHandle
      }, null, 8, ["tipShow"])
    ]),
    _hoisted_3
  ], 64))
}
}

})